const REPORT_FORMAT_PDF: string = 'pdf';

export default REPORT_FORMAT_PDF;
